import { render, staticRenderFns } from "./SnssaiTableMenu.vue?vue&type=template&id=2931be73&scoped=true&"
import script from "./SnssaiTableMenu.vue?vue&type=script&lang=js&"
export * from "./SnssaiTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2931be73",
  null
  
)

export default component.exports